import React from 'react';
import Plans from '../ForYouAndYourFamily/Plans';
import FormPlan from '../Form/FormPlan';
import urlBase from '../../../url-base';
import axios from 'axios';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Grid from '@material-ui/core/Grid';
import queryString from 'query-string';



class SalesRegistration extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      plans: false,
      chooseSalesmanFlag: false,
      chooseSalesmanSelect: 'null',
      listSalesman: [],
      disabledSalesmanSelect: false,
      selectPlan:'',
      removeContracts:[]
    };

    this.styles = {
      h1: {
        fontWeight: 100,
        textAlign: 'center',
        color: '#606060',
        fontSize: 30
      },
      input: {
        marginLeft: 10
      }
    };

    // Campos obrigatórios
    this.errorField = {
      chooseSalesmanSelect: ''
    };
  }

    componentWillMount() {
   // this.state.isServidor = this.props.isServidor;
   // TRATAR DAQUI PQ NÃO ESTÁ RECARREGANDO A PÁGINA QUANDO CLICA NOS MENUS

    //verifica se foi passado algo por parâmetro.
    //let teste = window.location.search;


    
    let params = queryString.parse(window.location.search);
    if(params.contract){
      this.loadPlan(params.cpf, params.contract);
    }

    let userType = localStorage.getItem('dental_y');

    if (userType == 'BROKER') {
      let state = this.state;
      state.chooseSalesmanFlag = true;
      state.chooseSalesmanSelect = localStorage.getItem('dental_v_i');
      this.setState(state);

      // Pega os dados da corretora
      axios.get(urlBase.loopBack + 'Brokers?filter={"where":{"userId":"'+localStorage.getItem('dental_u')+'"}}')
      .then((result) => {
        if (result.data && result.data.length > 0) {
          let filter = '{"where":{"brokerId":"'+result.data[0].id+'"},"include":"user"}';

          // Pega os dados do vendedor
          axios.get(urlBase.loopBack + 'Salesmans?filter='+filter)
          .then((result2) => {
            let state = this.state;
            state.listSalesman = result2.data;
            this.setState(state);
          })
          .catch(function (erro) {
            alert(erro);
          });
        }
        else
          alert("Vendedores não encontrados");

      })
      .catch(function (erro) {
        alert(erro);
      });
    }
    else if (userType == 'BACKOFFICE') {
      let state = this.state;
      state.chooseSalesmanFlag = true;
      state.chooseSalesmanSelect = localStorage.getItem('dental_v_i');
      this.setState(state);

      // Pega os dados da corretora
      axios.get(urlBase.loopBack + 'Accounts/me/broker?access_token='+localStorage.getItem('dental_t'))
      .then((result) => {
        if (result.data) {
          let filter = '{"where":{"brokerId":"'+result.data.id+'"},"include":"user"}';

          // Pega os dados do vendedor
          axios.get(urlBase.loopBack + 'Salesmans?filter='+filter)
          .then((result2) => {
            let state = this.state;
            state.listSalesman = result2.data;
            this.setState(state);
          })
          .catch(function (erro) {
            alert(erro);
          });
        }
        else
          alert("Vendedores não encontrados");

      })
      .catch(function (erro) {
        alert(erro);
      });
    }
  }
  // Paulo : Verificar aqui a warning : 'isServidor' is missing in props validation
  componentDidUpdate(prevProps) {
      if (prevProps.isServidor !== this.props.isServidor) {       
        this.setState({ isServidor: this.props.isServidor }, () => {
          // Recarrega os planos caso a mudança de servidor influencie a busca da API
        });
      }
  }


  onClickPlansPlan() {
    let state = this.state;
    let userType = localStorage.getItem('dental_y');

    if (userType == 'BROKER' || userType == 'BACKOFFICE') {
      // Caso ainda não tenha escolhido um vendedor
      if (this.state.chooseSalesmanSelect == 'null')
        this.errorField.chooseSalesmanSelect = 'Campo obrigatório';
      else {
        state.plans = true;
        this.errorField.chooseSalesmanSelect = '';
        state.disabledSalesmanSelect = true;
      }
    }
    else
      state.plans = true;

    this.setState(state);
  }

  onBackPlans(){
    let state = this.state;
    state.plans = false;
    this.setState(state);
  }


  loadPlan(cpf,contractId){
    let url = urlBase.loopBack + 'APIS4s/Associados';
    let dataPost = {
      cpf: cpf
    };

    axios.post(url, dataPost)
      .then((result) => {        
        let state = this.state;
        this.state.removeContracts;
        //BUG

        for (let i = 0; i < state.removeContracts.length; i++) {
          let codeToRemove = state.removeContracts[i];
          for (let e = 0; e < result.data.length; e++) {
            let code = result.data[e].Dependente[0].Id;
            if (code == codeToRemove) {
              result.data.splice(e, 1);
            }
          }
        }

        if (result.data.length >= 1) {
          this.setState({
              selectPlan: result.data[contractId]
          });          
          return false;
        }
        
      })
      .catch(function (erro) {
        
        alert('Tivemos um erro interno ao tentar carregar o plano, entre em contato com o suporte! Erro: '+ erro);        
      });

  }
  

  setPlanToAddDependents(){

    // localStorage.setItem("dental_plan", id);
    // localStorage.setItem("payment_plan", payment);
    // localStorage.setItem("type_plan", type);

  }

  // Monitora mudanças a atualiza estados do Select 'Vendedor'
  salesmanChange(event, index, payload) {
    let state = this.state;
    state.chooseSalesmanSelect = payload;

    if (this.state.chooseSalesmanSelect == 'null')
      this.errorField.chooseSalesmanSelect = 'Campo obrigatório';
    else
      this.errorField.chooseSalesmanSelect = '';

    this.setState(state);

    localStorage.setItem('dental_v_i', payload);
  }

  render() {
    return (
      <div>
        {/* <p className="title_panel_plans">CADASTRAR VENDAS</p> */}
        {
          this.state.chooseSalesmanFlag == true ? (
       
          <Grid container spacing={24}>
            <Grid item xs={12} sm={2} md={3} lg={3}>&nbsp;</Grid>

            <Grid item xs={12} sm={8} md={6} lg={6}>
              <SelectField
                disabled={this.state.disabledSalesmanSelect}
                style={this.styles.input}
                errorText={this.errorField.chooseSalesmanSelect}
                floatingLabelText="Vendedor *"
                fullWidth={true}
                name="type"
                value={this.state.chooseSalesmanSelect}
                onChange={this.salesmanChange.bind(this)}
              >
                <MenuItem value="null" primaryText="Escolha um vendedor" />
              {this.state.listSalesman.map((item, index) =>
                <MenuItem key={index} value={item.id} primaryText={item.user.name} />
              )}

              </SelectField>
            </Grid>

            <Grid item xs={12} sm={2} md={3} lg={3}>&nbsp;</Grid>
          </Grid>
          ) : ('')
        }

        {
          /* Escolhe o plano */
          this.state.plans == false ? (
            <Plans onClickFn={this.onClickPlansPlan.bind(this)} isServidor={this.props.isServidor}/>
          ) : (
            <FormPlan
              onClickFn={this.onBackPlans.bind(this)}
              salesmanId={this.state.chooseSalesmanSelect}
            />
          )
        }
      </div>
    );

  }

}

export default SalesRegistration;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/SalesRegistration/SalesRegistration.js
 **/